export default "__VITE_ASSET__C$ASftUf__"